/**
 * The short form of a takeover note in the user's bubble (design D20),
 * registered in the core registry `views/userMessageDisplays.ts`
 * (`agentUserMessageDisplays`), which hands it the panel's `t`. Kept apart
 * from `productSelectionSpec.ts` so the view registry does not depend on the
 * display.
 */
import type { TFunction } from "@msys/tolgee";
import { parseProductSelectionNote } from "./productSelectionSpec.js";

/** What the user's bubble shows for a takeover note (the JSON stays in the message); any other text is returned unchanged. */
export function displayProductSelectionNote(
  text: string,
  t: TFunction<"Assistant">
): string {
  const note = parseProductSelectionNote(text);
  if (!note) return text;
  const count = note.slots.reduce((sum, slot) => sum + slot.products.length, 0);
  return t(
    "Product selection taken over ({count, plural, one {# product} other {# products}})",
    { count, ns: "Assistant" }
  );
}
